import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'

export type OrganizationDetail = {
    _id: string
    name: string
    logoPath?: string
    lightModeImage?: string
    image?: string
    confidentialityFooter?: string
    isPicoEnabled?: boolean
    isMaiaEnabled?: boolean
    isAllowedUsersEnabled?: boolean
    isFreeTrial?: boolean
    freeTrialStartDate?: string
    userCount: number
    roadmapCount: number
    createdAt: string
    updatedAt: string
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminOrganizationDetailQuery = (orgId: string) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getOrganizationDetail = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.adminGetOrganizationDetail
            const response = await callAPI(`${url}${orgId}`, method, token)
            return response.data as OrganizationDetail
        } catch (e) {
            console.error('Error fetching organization detail:', e)
            throw e
        }
    }

    return useQuery<OrganizationDetail>(['admin', 'organization', orgId], getOrganizationDetail, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!orgId,
        cacheTime: FIVE_MINUTES,
        staleTime: 30000,
        retry: 3,
    })
}
